var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 18.1562H0.65625C0.2975 18.1562 0 17.8587 0 17.5C0 17.1413 0.2975 16.8438 0.65625 16.8438H16.4062C16.765 16.8438 17.0625 17.1413 17.0625 17.5C17.0625 17.8587 16.765 18.1562 16.4062 18.1562Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93125 5.58252H1.53125C1.05 5.58252 0.65625 5.97627 0.65625 6.45752V14C0.65625 14.4813 1.05 14.875 1.53125 14.875H2.93125C3.4125 14.875 3.80625 14.4813 3.80625 14V6.45752C3.80625 5.96752 3.4125 5.58252 2.93125 5.58252Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23105 2.79126H7.83105C7.3498 2.79126 6.95605 3.18501 6.95605 3.66626V14C6.95605 14.4813 7.3498 14.875 7.83105 14.875H9.23105C9.7123 14.875 10.1061 14.4813 10.1061 14V3.66626C10.1061 3.18501 9.7123 2.79126 9.23105 2.79126Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5313 0H14.1313C13.6501 0 13.2563 0.39375 13.2563 0.875V14C13.2563 14.4812 13.6501 14.875 14.1313 14.875H15.5313C16.0126 14.875 16.4063 14.4812 16.4063 14V0.875C16.4063 0.39375 16.0126 0 15.5313 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.01761ba00a3e74a0d3543f1fb47ebed4.svg";
export { ForwardRef as ReactComponent };